import { render, staticRenderFns } from "./RomaneioForm.vue?vue&type=template&id=b376593c"
import script from "./RomaneioForm.vue?vue&type=script&lang=js"
export * from "./RomaneioForm.vue?vue&type=script&lang=js"
import style0 from "./RomaneioForm.vue?vue&type=style&index=0&id=b376593c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b376593c')) {
      api.createRecord('b376593c', component.options)
    } else {
      api.reload('b376593c', component.options)
    }
    module.hot.accept("./RomaneioForm.vue?vue&type=template&id=b376593c", function () {
      api.rerender('b376593c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/customReports/components/forms/RomaneioForm.vue"
export default component.exports